import React from "react"
import HeaderMenu from "../components/header-menu"
import ZipFinder from '../components/zip-finder'

export default function Header(props) 
{
	const requestImageFile = require.context('../images/', true, /.png$/);
	const menu = props.menu;
	const env = props.env;
	const code = props.code;
	const button = env.site === 'dumpster' ? "Find Pros" : "Get Started";
	const finderopenmodal = env.site === 'dumpster' ? false : true;

	return (
		<nav id="sitenav" className="col-12 navbar navbar-expand-md navbar-light">			
			
			<div className="elements">
			
				<button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">   
					<span className="sr-only"></span>
					<span className="icon-bar"></span>
					<span className="icon-bar"></span>
					<span className="icon-bar"></span>    
				</button>

				<a className="nav-bar brand" href="/" title="Home">
					<img src={requestImageFile('./logo-'+env.site+'.png')} alt="logo"></img>
				</a>

			</div>
            
			<HeaderMenu menu={menu} />

			<ZipFinder 
				id={'header-zip-finder'} 
				env={env} 
				type={'small'} 
				code={code} 
				placeholder = "Enter Zip Code"
				button = {button}
				finderopenmodal={finderopenmodal}
				/>

		</nav>		
	);
}